import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { TwinTableLink } from '../../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { ProductExtendedTyShort } from '../../../../../../../../../specificComponents/Product/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { CustomRenderString, EditRow } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import locations from '../../../../../../../../../utils/globals/locations'
import { ParentAddonTy } from './types'
import NullComponent from '../../../../../../../../../baseComponents/NullComponent'

interface ParentsAddonProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
}

const ParentsAddon: React.FC<ParentsAddonProps> = ({ basicData, userPermissions }) => {

    const { t } = useTwinTranslation()

    const pageData = {
        title: t('productParents', 'Productos padre'),
        newText: ''
    }

    return (
        <BaseScreenTableInner TableComponent={TableParentsAddon} CreateModalComponent={NullComponent} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ 'ProductAddonId': basicData?.id }} basicData={basicData} />
    )
}

type TableParentsAddonProps = TableComponentBaseScreenInnerProps

const TableParentsAddon: React.FC<TableParentsAddonProps> = ({ setOpened, setTableInstance, extraWhereParams }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<ParentAddonTy> = [
        {
            id: 'ProductId',
            dataKey: 'ProductId',
            label: t('product', 'Producto'),
            minWidth: 130,
            searchKey: 'Product.ProductLangs.name',
            sortable: true,
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.['Product.reference'] + ' - ' + allRowData?.name} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('product', 'Producto') }
            },
        },
        {
            id: 'Product.ProductId',
            dataKey: 'Product.ProductId',
            label: t('productParent', 'Producto padre'),
            searchKey: 'Product.Product.ProductLangs.name',
            minWidth: 130,
            sortable: true,
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.['Product.Product.reference'] ? (allRowData?.['Product.Product.reference'] + ' - ' + allRowData?.['Product.Product.ProductLangs.name']) : ''} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('productParent', 'Producto padre') }
            },
        },
        {
            id: 'edit',
            dataKey: 'ProductAddonId',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }}/>
        },
    ]
    return (
        <TwinTableLink columns={columns} name='parentAddon' getDataFrom='/api/app/product/productAddon/getAllProductAddonParentsComplete'
        onRowClick={(_id, rowData) => setOpened({
            type: 'delete',
            allRowData: rowData
        })} setTableInstance={setTableInstance} defaultOrder={{ order: 'desc', defaultOrderField: 'ProductId' }} extraWhereParams={extraWhereParams} createRowDataLink={[locations.product, ['$id', 'main']]} />
    )
}

export default ParentsAddon